<app-section-loader [loading]="loading"></app-section-loader>
<div class="mContent__header bg-primary py-3 px-5">
  <h1 class="text-white mb-1">Student Directory</h1>
  <div class="mControls">
    <div class="input-group">
      <mat-form-field appearance="outline" class="input-white no-error search-field">
        <mat-label>Schools</mat-label>
        <mat-select
          [(ngModel)]="selectedSchool"
          (selectionChange)="onSchoolChange($event)"
          [disabled]="entireListSelected"
        >
          <mat-option [value]="-1"> All Schools </mat-option>
          <mat-option *ngFor="let school of schoolList" [value]="school.id">
            {{ school.school_name }}
            {{ school.uuid ? "(" + school.uuid + ")" : "" }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="input-group">
      <mat-form-field appearance="outline" class="input-white no-error search-field search-field--material-default">
        <mat-label>Grades</mat-label>
        <mat-select
          [(ngModel)]="levelSelected"
          (selectionChange)="onLevelChange($event)"
          [disabled]="entireListSelected"
        >
          <mat-option *ngFor="let level of levelList" [value]="level.id">
            {{ level.grade_level }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="input-group mr-auto">
      <mat-form-field appearance="outline" class="input-white no-error search-field">
        <mat-label>Search</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input
          type="text"
          matInput
          [(ngModel)]="studentInfo.searchTerm"
          (keyup.enter)="onSearch()"
          placeholder="Search by student or teacher"
          aria-label="Search"
        />
        <button
          mat-button
          *ngIf="studentInfo.searchTerm"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="studentInfo.searchTerm = ''; onSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div>
      <div class="mControls__right">
        <div class="input-group">
          <button
            class="mr-2"
            mat-raised-button
            (click)="goToTutorUpdateProgress()"
          >
          H.U.G. Classroom
          </button>
          <button
            *ngIf="loggedInUser !== tutorRoleId"
            mat-raised-button
            [matMenuTriggerFor]="menu"
          >
            Add New <mat-icon>expand_more</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngFor="let action of studentActions"
              (click)="studentAction(action)"
            >
              {{ action }}
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>
</div>
<hr class="m-0" />
<div class="scroll flex-fill overflow-auto pt-0 pb-3 px-5">
  <div class="position-relative h-100">
    <div class="mControls mControls--absolute">
      <div class="mControls__right">
        <div *ngIf="loggedInUser === tutorRoleId">
          <div class="input-group">
            <mat-form-field appearance="outline" class="no-error">
              <mat-label>Bulk Action</mat-label>
              <mat-select [(ngModel)]="selectedBulkAction" panelClass="hug-bulk-action-panel">
                <mat-option
                  *ngFor="let action of tutorBulkActions"
                  [value]="action"
                  >{{ action }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="loggedInUser !== tutorRoleId">
          <div class="input-group">
            <mat-form-field appearance="outline" class="no-error">
              <mat-label>Bulk Action</mat-label>
              <mat-select [(ngModel)]="selectedBulkAction" panelClass="hug-bulk-action-panel">
                <mat-option
                  *ngFor="let action of bulkActions"
                  [value]="action"
                  >{{ action }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="input-group">
          <button
            mat-flat-button
            color="primary"
            (click)="bulkAction()"
            [disabled]="selectedStudentList.length == 0 || !selectedBulkAction"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
    <mat-tab-group
      class="nav border-0"
      (selectedIndexChange)="setListForTab($event)"
      [selectedIndex]="selectedLabel"
    >
      <mat-tab
        *ngFor="let label of matTabLabels"
        [label]="label"
        class="nav-item"
      >
        <!--HUG Students,Control Group-->
        <ng-container *ngTemplateOutlet="tabContent"></ng-container>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<ng-template #tabContent>
  <div
    class="position-relative"
    style="height: calc(100vh - 278px); display: flex; flex-direction: column"
  >
    <app-section-loader [loading]="loadingList"></app-section-loader>
    <div
      *ngIf="filteredStudentList?.length > 0"
      class="search-results flex-fill overflow-auto m-3"
      infiniteScroll
      [infiniteScrollDistance]="0.025"
      [infiniteScrollThrottle]="1000"
      (scrolled)="onScrollDown()"
      [scrollWindow]="false"
    >
      <table class="table no-wrap m-0 table--hover">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Teacher</th>
            <th scope="col" style="width: 100px">Grade Level</th>
            <th scope="col" style="width: 100px">Zone Level</th>
            <th scope="col" *ngIf="selectedIndex === 0">Tutor Name</th>
            <th scope="col" *ngIf="selectedIndex === 0">Tutor Email</th>
            <th scope="col" style="width: 60px">&nbsp;</th>
            <th scope="col" style="width: 12px">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="selectAll"
                  (change)="selectAllUser($event)"
                  [checked]="entireListSelected"
                />
                <label class="custom-control-label" for="selectAll"></label>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let student of filteredStudentList">
            <td (click)="studentProfile(student?.id)">
              {{ isTutor ? maskLastName(student?.UserName) : student?.UserName }}
            </td>
            <td (click)="studentProfile(student?.id)">
              {{ student?.ClassName }}
            </td>
            <td (click)="studentProfile(student?.id)">
              <span class="text-primary weight-500">{{
                student?.Grade ? student?.Grade : "N/A"
              }}</span>
            </td>
            <td (click)="studentProfile(student?.id)">
              <span class="text-primary weight-500">{{
                student?.ZoneName ? student?.ZoneName : "N/A"
              }}</span>
            </td>
            <td
              (click)="studentProfile(student?.id)"
              *ngIf="selectedIndex === 0"
            >
              <div *ngIf="student?.tutor.length === 0">
                {{ "N/A" }}
              </div>
              <p *ngFor="let tutor of student?.tutor">
                {{ tutor?.UserName ? tutor?.UserName : "N/A" }}
              </p>
            </td>
            <td
              (click)="studentProfile(student?.id)"
              *ngIf="selectedIndex === 0"
            >
              <div *ngIf="student?.tutor.length === 0">
                {{ "N/A" }}
              </div>
              <p *ngFor="let tutor of student?.tutor">
                <span>{{ tutor?.email ? tutor?.email : "N/A" }}</span>
              </p>
            </td>
            <td>
              <div *ngIf="loggedInUser !== tutorRoleId">
                <a
                  class="cursor-pointer icon-btn"
                  (click)="editStudent(student?.id)"
                  aria-hidden="false"
                  aria-label="Edit"
                >
                  <mat-icon
                    matTooltip="Edit"
                    aria-hidden="false"
                    aria-label="Edit"
                    >edit</mat-icon
                  >
                </a>
              </div>
            </td>
            <td>
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="checkbox_{{ student?.id }}"
                  [value]="student?.id"
                  (change)="studentSelect($event, student)"
                  [checked]="student?.selected"
                />
                <label
                  class="custom-control-label"
                  for="checkbox_{{ student?.id }}"
                ></label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="flex-fill d-flex flex-column align-items-center justify-content-center"
      *ngIf="!filteredStudentList?.length"
    >
      <img src="assets/images/no-result.png" alt="" />
      <h2>No Student Records</h2>
    </div>
  </div>
</ng-template>
<div class="text-right flex-auto p-3 page-count">
  <span>{{ filteredStudentList?.length }}</span> of
  <span>{{ count }}</span>
</div>
